import { createSelector } from "@reduxjs/toolkit"

const selectBase = createSelector(
	(state: RootState) => state,
	state => state.filter
)

export const selectFilterInputs = createSelector(selectBase, state => state.inputs)
export const selectFilterLoading = createSelector(selectBase, state => state.loading)
export const selectFilterError = createSelector(selectBase, state => state.error)
export const selectFilterTotal = createSelector(selectBase, state => state.total)
